import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, startWith, takeWhile, tap } from 'rxjs/operators';
import { AutoLotView } from 'src/app/const';
import { LotViewsService } from 'src/app/services/lot-views.service';
import { SanctionsService } from 'src/app/services/sanctions.service';

import {
  Lot,
  LotDataFragment,
  LotSource,
  LotTypeEnum,
  UserLotMarkFragment,
} from '../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lots-list-lot-link',
  templateUrl: './lots-list-lot-link.component.html',
  styleUrls: ['./lots-list-lot-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotsListLotLinkComponent implements OnInit {
  @Input() lot: AutoLotView | Lot;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input() link: string | string[];
  @Input() lotData?: LotDataFragment;

  isLotSanctioned$: Observable<boolean>;
  isLotNotSanctioned$: Observable<boolean>;
  loaded$: Observable<boolean>;
  isVisited$: Observable<boolean>;

  constructor(
    private readonly lotViewsService: LotViewsService,
    private readonly sanctionsService: SanctionsService,
  ) {}

  ngOnInit(): void {
    this.isLotSanctioned$ = this.sanctionsService.isLotSanctioned$(this.lot);
    this.isLotNotSanctioned$ = this.isLotSanctioned$.pipe(map((v) => !v));
    this.loaded$ = combineLatest([this.isLotSanctioned$, this.isLotNotSanctioned$]).pipe(
      map((values) => values.some((v) => v)),
    );

    this.isVisited$ = this.lotViewsService.lotViewed$.pipe(
      tap(console.log),
      filter(
        (event) =>
          event.lotId === this.lot.id &&
          event.lotType === this.lotType &&
          event.lotSource === this.lotSource,
      ),
      map(() => true),
      startWith(!!this.lotData?.currentUserLastLotSourceView?.id),
      takeWhile((value) => !value, true),
    );
  }

  get hasBid(): boolean {
    return !!this.lotData?.currentUserLastBid?.id;
  }

  get marks(): UserLotMarkFragment[] {
    return this.lotData?.currentUserLotMarks ?? [];
  }

  get lotBid(): string | undefined {
    return 'bid' in this.lot ? this.lot.bid : this.lot.code;
  }
}
